export default __webpack_public_path__ + "static/media/mail.eb5a5f2c.svg";